import { Avatar, HStack, StackProps, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CurrentActiveUserInterface } from "../../constants/User";
import { useGetUserLoginStore } from "../../store/useGetUserLoginStore";
import { useUserHeader } from "../../store/useUserHeader";
import { useBgHover } from "../../themes/colors";

interface Props extends StackProps {
  user: CurrentActiveUserInterface;
}

export const UserNonActiveCard = ({ user, ...rest }: Props) => {
  const { saveCurrentActiveUser } = useGetUserLoginStore();
  const { fetchUserNonActive } = useUserHeader();
  const [userInfo, setUserInfo] = useState<
    CurrentActiveUserInterface | undefined
  >(undefined);
  const bgHover = useBgHover();

  const saveCurrentUser = (userParams: any) => {
    saveCurrentActiveUser(userParams);
  };

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchUserNonActive(user.id, `${user.role}`);
      setUserInfo(res);
    };

    fetchData();
  }, [fetchUserNonActive, user.id, user.role]);

  return (
    <HStack
      as={Link}
      to={`/${userInfo?.role}`}
      alignItems="center"
      py={4}
      px={1}
      cursor={"pointer"}
      onClick={() => saveCurrentUser(user)}
      borderRadius={"md"}
      _hover={{ bg: bgHover }}
      {...rest}
    >
      <Avatar
        src={
          userInfo?.image
            ? `${process.env.REACT_APP_MEDIA_URL}${userInfo?.image}`
            : ""
        }
        name={userInfo?.name || ""}
        objectFit="cover"
        size={"sm"}
      />

      <VStack w={"100%"} gap={0} align={"stretch"}>
        <Text textStyle={"b-reg-sb"} noOfLines={1} textOverflow={"ellipsis"}>
          {userInfo?.name}
        </Text>

        <Text textStyle={"b-sm-sb"} fontWeight={500} variant={"secondary"}>
          Akun&nbsp;
          {user?.role === "buyer"
            ? "Pembeli"
            : user?.role === "supplier"
            ? "Supplier"
            : "Reseller"}
        </Text>
      </VStack>
    </HStack>
  );
};
